import { cssVar } from '@mfw/common';
import type { Theme } from '@mui/material/styles';

import { tabClasses } from '@mui/material/Tab';
import { onSurface } from '../../onSurface';

// ----------------------------------------------------------------------

export function tabs(theme: Theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
              marginRight: theme.spacing(5),
            },
          },
          [`&.${tabClasses.selected}`]: {
            // NOT `primary.main`, which is MUI's default here: a brand colour
            // is picked to stand out on ONE surface ladder, and the selected
            // tab measured 1.74:1 on a light one. `onSurface` is the same brand
            // at the step that can be read on whichever surface is current —
            // computed per palette in `AppThemeProvider`, so it has no catalog
            // entry and no `cssVar` accessor to reach for.
            color: onSurface.primary,
          },
          [`&:not(.${tabClasses.selected})`]: {
            color: cssVar.text.secondary,
          },
          fontWeight: theme.typography.fontWeightSemiBold,
          minHeight: 48,
          minWidth: 48,
          opacity: 1,
          padding: 0,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          // The SAME step the selected label above is painted with. These two
          // are one control drawn in two files, and they disagreed: the label
          // was moved to the brand while the bar kept the text ladder, so a
          // green tab carried a white underline. `onSurface` and not
          // `primary.main` for the same reason the label uses it — the bar is
          // a non-text UI component, and `primary.main` reads 1.74:1 on a
          // cream tenant, under SC 1.4.11's 3:1.
          backgroundColor: onSurface.primary,
        },
        scrollButtons: {
          borderRadius: '50%',
          width: 48,
        },
      },
    },
  };
}
